// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { screen } from "@bg/XDL/Helpers";
import Clear from "@bg/XDL/Icons/Clear";
import { xBaseTheme } from "@bg/XDL/types";
import DrawerPresentationPropsDefault from "@insite/mobius/Drawer/presentationProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DrawerPresentationPropsDefault,
        cssOverrides: {
            drawerContainer: css`
                > div {
                    transition: 300ms ease-in-out;
                    background: ${getColor("common.ui4")};
                    min-width: 398px;
                    ${screen("lte", "sm")`
                        min-width:100%;`};
                }
                #drawerTitle {
                    > button {
                        padding: 0;
                        box-shadow: none !important;
                        border: 0 !important;
                        background: ${getColor("common.ui4")};
                        &:hover {
                            background: ${getColor("common.ui4")};
                            border-color: ${getColor("common.white")};
                        }
                    }
                }
            `,
            drawerTitle: css`
                background: ${getColor("common.ui4")};
                padding: 40px;
                padding-bottom: 0;
            `,
        },
        closeButtonIconProps: {
            src: "X",
            size: 24,
        },
        closeButtonProps: {
            shape: "pill",
            buttonType: "solid",
            size: 36,
            color: "common.background",
        },
    },
} as xBaseTheme["drawer"];
